import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./Notice.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import { GameContext } from "../../GameContext";
import apiManager from './../../ApiManager';

const Notice = ({ setModalType, arg, addModalType, set_screenId }) => {
    const [inProp, setInProp] = useState(false);
    const { preProcessEvent, friends } = useContext(GameContext);
    const [notifications, set_notifications] = useState([]);
    useEffect(() => {
        setInProp(true);
        apiManager.fetchGet(`auth/notifications`, {}, 0).then(notifications => {
            set_notifications(notifications.reverse());
        });
    }, [])
    function openLink(v) {
        console.log("v", v)
        /* apiManager.fetchPut(`auth/notifications/${v.notifications_id}`, {}, 0).then(readRes => {
            console.log("readRes", readRes);
        }) */
        switch (v.notifications_code) {
            case 'JOINING_REQUEST':
                addModalType({
                    cls: "JoinRequest", arg: {
                        joinVo: v
                    }
                });
                break;
            case 'INVITATION':
                apiManager.fetchGet(`event-invitations`, {}, 0).then(res => {
                    addModalType({
                        cls: "Invatation", arg: {
                            invitations: res
                        }
                    });
                })
                break;
            case 'FRIEND_REQUEST_ACCEPTED':
                console.log("friends", friends, v.notifications_identifier);
                const friend = friends.find(f => f.user_friends_id === v.notifications_identifier);
                console.log("friend", friend)
                if (friend) {
                    addModalType({ cls: "FriendPage", arg: { friendVo: friend } });
                }
                break;
            case "JOINING_NEW":
            case "EVENT_INFO":
            case 10:
            case 12:
                apiManager.fetchGet(`event/${v.notifications_identifier}`, {}, 0).then(res => {
                    console.log("res", res);
                    preProcessEvent(res).then(eventVo => {
                        console.log("eventVo=", eventVo)
                        addModalType({
                            cls: "EventDetail", arg: {
                                cb: () => {
                                },
                                vo: eventVo
                            }
                        })
                    })
                })
                break;
            case "BADGE_NEW":
                setInProp(false);
                break;
            case 2:
                addModalType({
                    cls: "CheckUser", arg: v
                })
                break;
            case 6:
                addModalType({
                    cls: "OtherArea", arg: {

                    }
                })
                break;
            case 8:
                addModalType({
                    cls: "Terms", arg: {

                    }
                })
                break;
            case 11:
                setInProp(false);
                set_screenId({ ind: 1 });
                break;
            case 13:
                setInProp(false);
                set_screenId(
                    {
                        ind: 2,
                        screenArg: {
                            type: "notice",
                            defaultOpenAlbumId: "s1"
                        }
                    });
                break;
            case 14:
                addModalType({
                    cls: "PhotoPreview", arg: {

                    }
                })
                break;
        }
    }

    function getText(v) {
        const color = "#3149CE";
        switch (v.notifications_code) {
            case "BADGE_NEW":
                return v.notifications_message.message;
            case "EVENT_INFO":
            case "JOINING_NEW":
                return v.notifications_message.message.formatWithColor({ str: v.notifications_message.data[0].events_name, color: color, fw: 700 });
            case "FRIEND_REQUEST_ACCEPTED":
            case "FRIEND_REQUEST":
            case "INVITATION":
                return v.notifications_message.message.formatWithColor({ str: v.notifications_message.data[0].users_name, color: color, fw: 700 });
            case 0:
            case 3:
            case 4:
                return v.template.formatWithColor({ str: v.arg.userVo.user_name, color: color, fw: 700 });
            case 1:
            case 9:
            case 11:
            case 12:
            case 14:
                return v.template.formatWithColor({ str: v.arg.eventVo.events_name, color: color, fw: 700 });
            case "JOINING_REQUEST":
                return v.notifications_message.message.formatWithColor({ str: v.notifications_message.data[0].users_name, color: color, fw: 700 }, { str: v.notifications_message.data[1].events_name, color: color, fw: 700 });
            case 2:
            case 13:
                return v.template.formatWithColor({ str: v.arg.userVo.user_name, color: color, fw: 700 }, { str: v.arg.eventVo.events_name, color: color, fw: 700 });
            case 5:
            case 6:
            case 8:
                return v.template;
            case 7:
                return v.template.formatWithColor({ str: v.arg.countryName, color: color, fw: 700 }, { str: v.arg.progressPercent, color: color, fw: 700 });
            default:
                console.log("no", v)
                break;
        }

    }
    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Notice"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                            <YStyled.Span fontWeight={500} size={22}>通知</YStyled.Span>
                        </div>
                        <div className={styleUi.view}>
                            {notifications.map((v, k) => {
                                return <YStyled.Col gap=".5rem" key={k} className={`${styleUi.item} ${v.isRead ? styleUi.read : ""}`} /* onClick={
                                    e => {
                                        clickItem(v);
                                    }
                                } */>
                                    <YStyled.Row onClick={e => { openLink(v) }}>
                                        <YStyled.Span size={15} fontWeight={400}>
                                            {getText(v)}
                                        </YStyled.Span>
                                    </YStyled.Row>
                                    {v.notifications_code === "FRIEND_REQUEST" &&
                                        <YStyled.Row align="flex-end" gap=".4rem">
                                            <YStyled.BTN3 normalBg="white" normalColor="#3149CE" style={{ border: "solid 1px #3149CE", borderRadius: "8px", padding: ".4rem 1.2rem" }} onClick={e => {
                                                console.log(v.notifications_message.data[0].users_id)
                                                apiManager.fetchDelete(`user/friends/${v.notifications_message.data[1].user_friends_id}?Notification_Id=${v.notifications_id}`, {}, 0).then(res => {
                                                    set_notifications(prev=>prev.filter(_v=>_v.notifications_id!==v.notifications_id))
                                                })
                                            }}>
                                                <YStyled.Span size={15}>婉拒</YStyled.Span>
                                            </YStyled.BTN3>
                                            <YStyled.BTN3 normalBg="#3149CE" normalColor="white" style={{ border: "solid 1px #3149CE", borderRadius: "8px", padding: ".4rem 1.2rem" }} onClick={e => {
                                                console.log(v)
                                                //arg.notifications=arg.notifications.filter(vv=>vv.notifications_id==v.notifications_id);
                                                console.log(v.notifications_message.data[0].users_id)
                                                apiManager.fetchPut(`user/friends/${v.notifications_message.data[1].user_friends_id}?Notification_Id=${v.notifications_id}`, {}, 0).then(res => {
                                                    set_notifications(prev=>prev.filter(_v=>_v.notifications_id!==v.notifications_id))
                                                }).catch(err=>{
                                                    alert(err)
                                                })
                                            }}>
                                                <YStyled.Span size={15}>接受</YStyled.Span>
                                            </YStyled.BTN3>
                                        </YStyled.Row>
                                    }
                                </YStyled.Col>
                            })}
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Notice);